/**
 * Dominio base de tenants y destinos DNS para dominio propio.
 * UI: CNAME hacia food.structura.com.ar (mismo sitio Netlify).
 * Verificación: acepta también el hostname .netlify.app por si el proveedor lo exige.
 */

const stripTrailingDot = (h: string) => h.trim().replace(/\.$/, "");

function env(key: string): string | undefined {
  if (typeof process !== "undefined" && process.env?.[key]) {
    return stripTrailingDot(String(process.env[key]));
  }
  return undefined;
}

function viteEnv(key: string): string | undefined {
  if (typeof import.meta !== "undefined" && import.meta.env?.[key]) {
    return stripTrailingDot(String(import.meta.env[key]));
  }
  return undefined;
}

export const DEFAULT_TENANT_BASE_DOMAIN = "structura.com.ar";
export const DEFAULT_NETLIFY_DNS_TARGET = "foodmarketstructura.netlify.app";

/** Zona pública (marketing + storefronts). Ej. {tenant}.structura.com.ar */
export function getTenantBaseDomain(): string {
  return (
    env("TENANT_BASE_DOMAIN") ??
    viteEnv("VITE_TENANT_BASE_DOMAIN") ??
    DEFAULT_TENANT_BASE_DOMAIN
  );
}

/** Hostname Netlify del sitio FM (verificación DNS alternativa). */
export function getNetlifyDnsTarget(): string {
  return (
    env("NETLIFY_DNS_TARGET") ??
    viteEnv("VITE_NETLIFY_DNS_TARGET") ??
    DEFAULT_NETLIFY_DNS_TARGET
  );
}

/** Destino que mostramos al comercio al configurar dominio propio. */
export function getCustomDomainCnameDisplayTarget(): string {
  return getTenantBaseDomain();
}

/** Todos los destinos CNAME que consideramos válidos al verificar. */
export function getCustomDomainVerificationTargets(): string[] {
  const seen = new Set<string>();
  // Custom domains verified before the storefront move still CNAME to the FM site; keep accepting both sites.
  for (const h of [getTenantBaseDomain(), getNetlifyDnsTarget(), DEFAULT_NETLIFY_DNS_TARGET, "saas-frontstore.netlify.app", "structura-food-market.netlify.app"]) {
    if (h) seen.add(stripTrailingDot(h).toLowerCase());
  }
  return [...seen];
}
